// Get current financial year dynamically (Indian FY: April 1st to March 31st)
export const getCurrentFinancialYear = () => {
  const currentDate = new Date();
  const currentMonth = currentDate.getMonth() + 1; // getMonth() returns 0-11
  const currentYear = currentDate.getFullYear();

  // If current month is January, February, or March (1-3),
  // we're in the previous calendar year's financial year
  if (currentMonth >= 1 && currentMonth <= 3) {
    return `${currentYear - 1}-${currentYear.toString().slice(-2)}`;
  } else {
    // If current month is April to December (4-12),
    // we're in the current calendar year's financial year
    return `${currentYear}-${(currentYear + 1).toString().slice(-2)}`;
  }
};

export const getFinancialYearOptions = () => {
  const options = [];

  // Always start from FY 2024-25
  const startYear = 2024;

  // Build until the current FY, inclusive (Indian FY: Apr-Mar)
  const currentFY = getCurrentFinancialYear(); // e.g. "2025-26"
  const endYear = Number(String(currentFY).split("-")[0]); // 2025

  for (let year = startYear; year <= endYear; year++) {
    options.push(`${year}-${(year + 1).toString().slice(-2)}`);
  }

  return options;
};
